<script>
    import { Route } from 'svelte-router-spa'


    import Footer from '../global/footer.svelte'
    
    export let currentRoute;
    console.log( currentRoute );
    const params = {}
</script>

<style>

</style>


<main>

     <Route {currentRoute} {params} />

</main>



<Footer />